import { isDate, isArray, isObject, transform, camelCase, snakeCase } from 'lodash'

export function camelize(object) {
  if (isDate(object)) {
    return object
  } else if (isArray(object)) {
    return object.map(function(o) {
      return camelize(o);
    });
  } else if (isObject(object)) {
    return transform(object, function(result, v, k: string) {
      if (!k.startsWith('$')) {
        result[camelCase(k)] = camelize(v);
      }
      return result;
    });
  } else {
    return object;
  }
};

export function snakeize(object) {
  if (isDate(object)) {
    return object
  } else if (isArray(object)) {
    return object.map(function(o) {
      return snakeize(o);
    });
  } else if (isObject(object)) {
    return transform(object, function(result, v, k: string) {
      if (!k.startsWith('$')) {
        result[snakeCase(k)] = snakeize(v);
      }
      return result;
    });
  } else {
    return object;
  }
};

export function humanize<T>(value: T) {
  if (typeof value === "string") {
    return value.replace(/_/g, ' ').replace(/[A-Z]+/g, function ($1, offset) {
      if (offset === 0) {
        return $1;
      } else if ($1.length > 1) {
        return ' ' + $1;
      } else {
        return ' ' + $1.toLowerCase();
      }
    });
  }
  return value;
};
